var React = require('react');

function IcnChevronThick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 11.0903C24 11.5782 23.7984 12.0684 23.3952 12.4411C22.5888 13.1863 21.2808 13.1863 20.4744 12.4411L12 4.60911L3.5256 12.441C2.7192 13.1863 1.4112 13.1863 0.604797 12.441C-0.201603 11.6958 -0.201603 10.4869 0.604798 9.74168L10.5384 0.55895C10.9272 0.201844 11.4504 8.10228e-07 12 8.58275e-07C12.5496 9.06323e-07 13.0728 0.201844 13.4616 0.55895L23.3952 9.74168C23.7984 10.1143 24 10.6023 24 11.0925L24 11.0903Z","fill":"#000"}));
}

IcnChevronThick.defaultProps = {"width":"24","height":"13","viewBox":"0 0 24 13","fill":"none"};

module.exports = IcnChevronThick;

IcnChevronThick.default = IcnChevronThick;
